import { API_BASE_PATH } from '../../../../app/containers/App/constants'
import {
  GET_ACTIVE_SUBSCRIPTIONS_TOURNAMENT_URL,
  GET_GAME_TOURNAMENTS_ONGOING_SHOWCASE_URL,
  GET_GAME_VIP_TOURNAMENTS_ONGOING_SHOWCASE_URL,
  GET_SUBSCRIBE_TOURNAMENT_URL,
} from '../../../../app/containers/Tournaments/constants'
import { UserMembership } from '../../../../app/containers/Tournaments/types/UserMembership'
import { tournamentsListSchema } from '../../../../app/containers/Tournaments/validator'
import { userMembershipsListSchema } from '../../../../app/containers/Tournaments/validator/userMembership'
import { GET_AUTHORIZATION_DATA_URL } from '../../../../app/containers/WebSocketProvider/service/utils'
import { authorizationDataSchema } from '../../../../app/containers/WebSocketProvider/service/validators'
import { AuthorizationData } from '../../../../app/containers/WebSocketProvider/types'
import { getJson, post } from '../../../ajax'

export async function getGameTournaments(slug: string) {
  const url = getFullUrl(GET_GAME_TOURNAMENTS_ONGOING_SHOWCASE_URL(slug))

  const { data } = await new Promise<any>((resolve) => {
    getJson(url, (tournaments: any) => resolve(tournaments))
  })

  return tournamentsListSchema.validate(data)
}

export async function getGameVIPTournaments(slug: string, playerLevel: string) {
  const url = getFullUrl(GET_GAME_VIP_TOURNAMENTS_ONGOING_SHOWCASE_URL(slug, playerLevel))

  const { data } = await new Promise<any>((resolve) => {
    getJson(url, (tournaments: any) => resolve(tournaments))
  })

  return tournamentsListSchema.validate(data)
}

export async function getUserMemberships(): Promise<UserMembership[]> {
  const url = getFullUrl(GET_ACTIVE_SUBSCRIPTIONS_TOURNAMENT_URL())

  const { data } = await new Promise<any>((resolve) => {
    getJson(url, (userMemberships: any) => resolve(userMemberships))
  })

  return userMembershipsListSchema.validate(data)
}

export async function subscribeTournament(tournamentId: number) {
  const url = getFullUrl(GET_SUBSCRIBE_TOURNAMENT_URL(tournamentId))

  const response = await new Promise((resolve) => {
    post(url, null, null, (res: any) => resolve(res))
  })

  return response
}

export async function getWebSocketAuthorizationData() {
  const url = getFullUrl(GET_AUTHORIZATION_DATA_URL())

  const { data } = await new Promise<any>((resolve) => {
    getJson(url, (authorizationData: AuthorizationData) => resolve(authorizationData))
  })

  return authorizationDataSchema.validate(data)
}

function getFullUrl(url: string) {
  return `${API_BASE_PATH}${url}`
}
